import React from 'react';
import PropTypes from 'prop-types';
import AbstractHeader, { LazyBrowserDeprecationBanner } from '@ux/abstract-header';
import AccountDelegation from '@ux/account-delegation';
import { Customer } from '@ux/header-util';
import { IntlProvider } from 'react-intl';

/**
 * Render and expose the Header as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} No Header.
 * @api public
 */
class Header extends AbstractHeader {
  constructor() {
    super(...arguments);

    this.state = {
      ...this.state,

      // no-header does not render any components that require the GUI call by default
      unauthenticated: true
    };

    const noop = function () {};
    // `no-header` does not support navigation nor help UI, but we expose these
    // methods to provide compatibility when swapping in `no-header` for other
    // headers like `application-header`
    this.updateNavigation = this.updateTopNavigation = this.updateHelpUrl = noop;
  }

  createCustomer() {
    return new Customer(this.props);
  }

  render() {
    const {
      market,
      messages,
      urls,
      supportMatrix,
      whitelistedUserAgents,
      disableDeprecationBanner,
      blacklistedBrowsers,
      hideAccountDelegationBanner
    } = this.props;

    return (
      <IntlProvider locale={ market } messages={ messages }>
        { !hideAccountDelegationBanner && (
          <AccountDelegation
            market={ market }
            messages={ messages }
            action={ urls.sso.exitDelegation.href }
            restoreCookie={ urls.sso.restoreCookie.href }
            customer={ this.customer }
          />
        ) }
        <LazyBrowserDeprecationBanner
          supportMatrix={ supportMatrix }
          whitelistedUserAgents={ whitelistedUserAgents }
          disableDeprecationBanner={ disableDeprecationBanner }
          blacklistedBrowsers={ blacklistedBrowsers }
          urls={ urls } />
      </IntlProvider>
    );
  }
}

Header.propTypes = {
  messages: PropTypes.object.isRequired,
  urls: PropTypes.object.isRequired,
  market: PropTypes.string,
  hideAccountDelegationBanner: PropTypes.bool,
  supportMatrix: PropTypes.object.isRequired,
  whitelistedUserAgents: PropTypes.array,
  disableDeprecationBanner: PropTypes.bool,
  blacklistedBrowsers: PropTypes.arrayOf(
    PropTypes.shape({
      browser: PropTypes.string,
      version: PropTypes.number
    })
  )
};

Header.defaultProps = {
  hideAccountDelegationBanner: false
};

const Footer = () => null;

export { Header, Footer };
